export default "__VITE_ASSET__CXSIoBRE__"